import React, { useEffect, useRef, useState } from 'react'

import { Box } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

import useStyles from './styles'

const OTPForm = () => {
  const [inputValues, setInputValues] = useState(Array(5).fill(''))
  const [selectedInput, setSelectedInput] = useState(0)

  const classes = useStyles()
  const ref = useRef()
  const { setValue, errors, register } = useFormContext()

  const normalizeIndex = (index) => {
    if (index > 4) return 4
    if (index < 0) return 0
    return index
  }

  const handleInput = (index, value) => {
    if (value !== '' && !/^\d$/.test(value)) return

    setInputValues([
      ...inputValues.slice(0, index),
      value,
      ...inputValues.slice(index + 1),
    ])

    if (value !== '' && index !== 4) setSelectedInput(normalizeIndex(index + 1))
  }

  const handleBack = (event) => {
    if (event.key !== 'Backspace') return
    if (inputValues[selectedInput] !== '') return
    setSelectedInput((prev) => normalizeIndex(prev - 1))
  }

  const handlePaste = (event) => {
    const pastedValue = event.clipboardData.getData('text')
    setInputValues(inputValues.map((_, index) => pastedValue[index] || ''))
  }

  const handleFocus = (event) => {
    const inputIndex = Number(event.target.id)
    if (selectedInput !== inputIndex) setSelectedInput(inputIndex)
  }

  useEffect(() => {
    const element = document.getElementById(normalizeIndex(selectedInput))
    if (element) element.focus()
  }, [selectedInput])

  useEffect(() => {
    setValue('code', inputValues.join(''))
    // eslint-disable-next-line
  }, [inputValues])

  return (
    <Box className={classes.container} my={4}>
      <input type="hidden" name="code" ref={register} />
      {inputValues.map((value, index) => (
        <input
          key={index}
          id={index}
          className={`${classes.input} ${
            !!errors.code ? classes.inputError : ''
          }`}
          maxLength="1"
          onChange={(event) => handleInput(index, event.target.value)}
          onFocus={handleFocus}
          onKeyDown={handleBack}
          onPaste={handlePaste}
          ref={ref}
          type="text"
          value={value}
        />
      ))}
    </Box>
  )
}

export default OTPForm
